import React from 'react';
import { ModalContextValue } from './iModal';

const ModalContext = React.createContext<ModalContextValue | null>(null);

export default ModalContext;
